/**
 * Persist wizard exit path in sessionStorage across step changes and page reloads.
 * Set on wizard entry; read on Save / Cancel / Back from first step.
 */

export const BRAND_WIZARD_RETURN_TO_KEY = "spice:brand-wizard-return-to";
export const BRANCH_WIZARD_RETURN_TO_KEY = "spice:branch-wizard-return-to";
export const GROUP_WIZARD_RETURN_TO_KEY = "spice:group-wizard-return-to";

/** Overwrite return path (call when entering a wizard). */
export function setWizardReturnTo(key: string, path: string): void {
  sessionStorage.setItem(key, path);
}

/** Keep existing value; set only if missing (reload / deep link safety). */
export function ensureWizardReturnTo(key: string, path: string): void {
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, path);
  }
}

/** Read and clear — use when leaving the wizard. */
export function consumeWizardReturnTo(key: string): string | null {
  const value = sessionStorage.getItem(key);
  if (value) {
    sessionStorage.removeItem(key);
  }
  return value;
}
